const styles = {
  imageContainer: {
    width: '100%',
    height: '100%',
    '& > div': {
      position: 'unset !important',
      border: '1px solid red',
    },
    '& .img': {
      objectFit: 'cover',
      width: '100% !important',
      position: 'relative !important',
      height: 'unset !important',
    },
  },
}

export default styles
